export function getDaysDifference(date1, date2) {
    // Convert both dates to milliseconds
    const date1Ms = date1.getTime();
    const date2Ms = date2.getTime();

    // Calculate the difference in milliseconds
    const differenceMs = date2Ms - date1Ms;

    // Convert the difference to days
    return Math.floor(differenceMs / (1000 * 60 * 60 * 24));
}

export function getDateAt12AM(date = new Date()) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function dateAddDays(date, days) {
    return new Date(date.setDate(date.getDate() + days));
}

// get date object based on format
export function getDate(date, format) {
    if(date.indexOf('.') !== -1) {
        date = date.replace(/\./g, '-');
    } else {
        date = date.replace(/\//g, '-');
    }
    format = format.toLowerCase().replace(/\//g, '-');
    const dateParts = date.split('-');
    const formatParts = format.split('-');
    let dayKey, monthKey, yearKey;
    for (let i = 0; i < formatParts.length; i++) {
        if(formatParts[i].includes('d')) {
            dayKey = formatParts[i];
        }
        if(formatParts[i].includes('m')) {
            monthKey = formatParts[i];
        }
        if(formatParts[i].includes('y')) {
            yearKey = formatParts[i];
        }
    }

    const day = parseInt(dateParts[formatParts.indexOf(dayKey)]);
    const month = parseInt(dateParts[formatParts.indexOf(monthKey)]) - 1;
    const year = parseInt(dateParts[formatParts.indexOf(yearKey)]);

    return new Date(year, month, day);
}

// format date object to string date based on format
export function formatDate(date, format = 'mm/dd/yyyy') {
    const formatters = {
        'yyyy': date.getFullYear(),
        'mm': (date.getMonth() + 1).toString().padStart(2, '0'),
        'dd': date.getDate().toString().padStart(2, '0')
    };

    return format.replace(/yyyy|mm|dd/g, match => formatters[match]);
}
